import React, {useCallback} from "react";
import MenuItem from "../../../basics/menu/MenuItem";
import Menu from "../../../basics/menu/Menu";
import {downloadFile} from "../../../../api/files/downloadFile";
import {useTranslation} from "react-i18next";

export default function DesktopCalendarTaskDrawerFileMenu({
    menu,
    fileObject,
    onRemoveClick,
    onPreviewClick,
    onShareClick,
    // rodzic moze przejac pobieranie, gdy sam pilnuje stanu ladowania
    onDownloadClick,
    canShowPreview = false,
    isMarkedForRemove = false,
    readOnly = false,
    closeCallback,
}) {
    const {t} = useTranslation();

    // event leci dalej, bo rodzic musi go zatrzymac - menu siedzi w portalu,
    // ale klik i tak bulgocze w gore drzewa Reacta
    const onDownloadItemClick = useCallback(
        (e) => {
            if (onDownloadClick) {
                onDownloadClick(e);
                return;
            }
            e?.stopPropagation?.();
            downloadFile(fileObject);
        },
        [fileObject, onDownloadClick]
    );

    return (
        <Menu event={menu} {...(closeCallback ? {closeCallback} : {})}>
            {!!canShowPreview && !!onPreviewClick && (
                <MenuItem
                    icon={
                        <i className="fa-solid fa-up-right-from-square fa-fw" />
                    }
                    onClick={onPreviewClick}>
                    {t("preview")}
                </MenuItem>
            )}

            {fileObject && (
                <MenuItem
                    icon={<i className="fa-solid fa-download fa-fw" />}
                    onClick={onDownloadItemClick}>
                    {t("newReports.headers.download")}
                </MenuItem>
            )}

            {fileObject && !!onShareClick && (
                <MenuItem
                    icon={<i className="fa-solid fa-share-nodes fa-fw" />}
                    onClick={onShareClick}>
                    {t("share")}
                </MenuItem>
            )}

            {!readOnly && (
                <MenuItem
                    icon={
                        <i
                            className={`fa-solid fa-fw ${
                                isMarkedForRemove
                                    ? "fa-rotate-left"
                                    : "fa-trash"
                            }`}
                        />
                    }
                    onClick={onRemoveClick}>
                    {isMarkedForRemove ? t("cancel") : t("delete")}
                </MenuItem>
            )}
        </Menu>
    );
}
